var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "diglog-card",
      attrs: {
        id: "notification",
        visible: _vm.dialogVisible,
        title: _vm.$t("components.notification"),
        "append-to-body": "",
        "close-on-click-modal": false,
        width: "509px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "top-container" }, [
        _c("div", { staticClass: "tag" }, [_vm._v("UPDATE")]),
        _c("img", {
          staticStyle: { width: "231px", height: "66px" },
          attrs: {
            id: "notification-banner",
            src: require("@/assets/img/notification_banner.png"),
          },
        }),
        _c("div", { staticClass: "top-txt-container" }, [
          _c("div", { staticClass: "top-txt-1" }, [
            _vm._v(" " + _vm._s(_vm.detailData.title) + " "),
          ]),
          _c("div", { staticClass: "top-txt-2" }, [
            _vm._v(_vm._s(_vm.detailData.notice_actual_time)),
          ]),
        ]),
      ]),
      _c(
        "div",
        [
          _c("p", { staticClass: "txt" }, [
            _vm._v(_vm._s(_vm.detailData.content)),
          ]),
          _vm.detailData.type === 1 && _vm.detailData.data
            ? _c("ChannelFee", {
                attrs: { "fee-data": JSON.parse(_vm.detailData.data) },
              })
            : _vm._e(),
          _vm.detailData.notice_file_resp_list &&
          _vm.detailData.notice_file_resp_list.length > 0
            ? _c("div", { staticClass: "attachment-section" }, [
                _c("div", { staticClass: "attachment-title" }, [
                  _vm._v(_vm._s(_vm.$t("no_auth.attachment"))),
                ]),
                _c(
                  "div",
                  { staticClass: "attachment-list" },
                  _vm._l(
                    _vm.detailData.notice_file_resp_list,
                    function (file, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "attachment-item" },
                        [
                          _c("i", { staticClass: "el-icon-document" }),
                          _c("span", { staticClass: "file-name" }, [
                            _vm._v(_vm._s(file.file_name)),
                          ]),
                          _c(
                            "el-button",
                            {
                              staticClass: "download-btn",
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.downloadFile(
                                    file.file_oss_url,
                                    file.file_name
                                  )
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-download" })]
                          ),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-close",
              attrs: { type: "info" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("components.close")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }